import createIcon from '../../createIcon';

/**
 * @component @name FileDownloadDone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxOEgxOVYyMEg1VjE4Wk05LjYgMTUuM0w1IDEwLjdMNyA4LjhMOS42IDExLjRMMTcgNEwxOSA2TDkuNiAxNS4zWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileDownloadDone = createIcon('FileDownloadDone', [
  [
    'path',
    { d: 'M5 18H19V20H5V18ZM9.6 15.3L5 10.7L7 8.8L9.6 11.4L17 4L19 6L9.6 15.3Z', key: 'c6ag7h' },
  ],
]);

export default FileDownloadDone;
